import "@dxos/node-std/globals"
import {
  Framer,
  Muxer,
  Teleport,
  TestExtension,
  decodeFrame,
  encodeFrame
} from "./chunk-JWCTCCDW.mjs";

// packages/core/mesh/teleport/src/rpc-extension.ts
import assert from "@dxos/node-std/assert";
import { createProtoRpcPeer } from "@dxos/rpc";
var RpcExtension = class {
  constructor(_rpcParams) {
    this._rpcParams = _rpcParams;
    this._isClosed = false;
  }
  get initiator() {
    return this._extensionContext.initiator;
  }
  get localPeerId() {
    return this._extensionContext.localPeerId;
  }
  get remotePeerId() {
    return this._extensionContext.remotePeerId;
  }
  get rpc() {
    assert(this._rpc);
    return this._rpc.rpc;
  }
  async onOpen(context) {
    this._extensionContext = context;
    const handlers = await this.getHandlers();
    if (this._isClosed) {
      return;
    }
    const port = context.createPort("rpc", {
      contentType: 'application/x-protobuf; messageType="dxos.rpc.Message"'
    });
    this._rpc = createProtoRpcPeer({
      ...this._rpcParams,
      handlers,
      port
    });
    await this._rpc.open();
  }
  async onClose(err) {
    var _a;
    this._isClosed = true;
    await ((_a = this._rpc) == null ? void 0 : _a.close());
  }
  close() {
    this._extensionContext.close();
  }
};
export {
  Framer,
  Muxer,
  RpcExtension,
  Teleport,
  TestExtension,
  decodeFrame,
  encodeFrame
};
//# sourceMappingURL=index.mjs.map
